
export function GetKey(longitud: number, opcion: number): string {
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789=/.';
    let resultado = '';

    switch (opcion) {
        case 0:
            for (let i = 0; i < longitud; i++) {
                const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
                resultado += caracteres[indiceAleatorio];
            }
            break;
        case 1:

            if (longitud === ((10 + 20) * 3 * 2 - (2 ** 3))) {
                resultado = "";
                resultado += "ODRhOWE1MTVmY2YyMzExMTRhZTI2YzkwOWJkODFjMjQyMm";
                resultado += "Y1NjY3MzQ0NTRjMDk2MDA1OTg0YjQ1MDE0MmQ5M2ZlYzQz";
                resultado += "ZWFkYjkyYmIwNWYzNzU0MjAxMDE2MWZkMDYwMjBmODZjYW";
                resultado += "M3YWExMTViMTk0OTgyNDU3MTEyNjM2MTM=";
            } else {
                for (let i = 0; i < longitud; i++) {
                    const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
                    resultado += caracteres[indiceAleatorio];
                }    
            }
            break;
        case 2:
            if (longitud === (3 ** (2+2)) * 2 + (3 ** 2) + 1) {
                resultado = "";
                resultado += "Mzk3YTgzMWNkZWQzNmY4NjkxODA3ZTAzMTFiMzE4YWUwYzI5ZjE";
                resultado += "0NmI0Njg5OGY4MjhkMmIwMjM3N2Q2ZDZkZWQ5ZjBkZjgzZTBmYW";
                resultado += "VlZjhlYzIyZTkyN2Q1YTAxYmY2ZWNkNjM2M2JkZDhmOGIzOWQ5Y";
                resultado += "TUzMGE3MWY3YTEzODM=";
            } else {
                for (let i = 0; i < longitud; i++) {
                    const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
                    resultado += caracteres[indiceAleatorio];
                }    
            }
            break;
        case 3:
            if (longitud === (2 * 3 * 4 * 5) + (2 * 3 * 4) + (7 * 4)) {
                resultado = "";
                resultado += "MjZhMmUyYTJjNmE3MmMyYjAzOGMyZmMyZjk1YzEyNjAwMzU1OWJhYmFm";
                resultado += "MmUxYzE3MDcwY2JiOTg2MjYzZmU2ZjU2Yzk5YTUwMjAzOWJhYThiNTBj";
                resultado += "ZDE5YzVkZDMxOTMzMTcwOGVmNTU4Y2FlMzgwN2VlM2E5YTU4ZGJiZGU2";
                resultado += "MTU=";
            } else {
                for (let i = 0; i < longitud; i++) {
                    const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
                    resultado += caracteres[indiceAleatorio];
                }    
            }
            break;
        case 4:
            if (longitud === ((2 ** 3) * 4 * 5) + (3 * 4)) {
                resultado = "";
                resultado += "ZmVkNDMxNmFiNWY5YTg0ZmU3YWUxMjk4YjAxNGFlOTkzOTk5OWZiYTViNDgyNDQxODQ3M2I4YjE4MjlkNzJjZWUyODMxNTM2MDAzY2QyNTBmNDViNzYwZGIxOWJmM2M1M2MwMjNiZTAxNjc1NjY3MWMwNjRjNjAzYTZlNjFkZTA=";
            } else {
                for (let i = 0; i < longitud; i++) {
                    const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
                    resultado += caracteres[indiceAleatorio];
                }    
            }
            break;
        case 5:
            if (longitud === ((2 ** 3) * 4 * 5) + (3 * 4)) {
                resultado = "";
                resultado += "MzM5YTAxYzdkOGMxY2M4ZDdiYzVlNDU5ZTllMmE0YTA2MmM4Y2JhOWYwNjFhNzFlNDBjM";
                resultado += "DlhNzA1MzJjZDhlNzRjMjhiZTE2YWY0ZGQ2NGM2NGU4ODkwYzIzN2M1MDQ1OGI5ZDA1Yz"
                resultado += "A1MWE0NWVmYThhODA5OGMwMDgyMDdmMzE=";
            } else {
                for (let i = 0; i < longitud; i++) {
                    const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
                    resultado += caracteres[indiceAleatorio];
                }    
            }
            break;
        case 6:
            if (longitud === ((20 * 4 * 2) + (3 * 3) + 3)) {
                resultado = "";
                resultado += "ZjczZDFhMTNkYmExNzIzNTIzOTVkZGI4M2QxNmQ5NjE0ZmZhNjYzYTFkZDFlNmQwYWIyMjdmMWU5NWVmZWRkMjA0NTc1MzI1MmMzZDEwYWQwNTJlODU0OTUyNzM1MDU1MTUyYWNmOGY3M2RmMWJlZWEwNGQ0MzcwNjlmMmJjMjU=";
            } else {
                for (let i = 0; i < longitud; i++) {
                    const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
                    resultado += caracteres[indiceAleatorio];
                }    
            }
            break;
        case 7:
            break;
        default:
            break;
    }

    return resultado;
}
